// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"480":"7083ac4c","1383":"7083ac4c","3140":"2b1d1540","8705":"7cfcb020"}[chunkId] + ".chunk.css";
};